<template>
    <v-dialog v-model="show"  max-width="800">
      <template v-slot:activator="{on}">
        <slot name="activator" :on="on">
          <v-btn v-on="on" color="orange darken-1" icon><v-icon>edit</v-icon></v-btn>
        </slot>
      </template>
      <v-card :disabled="loading" :loading="loading">
        <v-card-title>Edit: {{sample.id}}</v-card-title>
        <v-card-text>
          <v-form ref="form" v-if="form">
            <v-row>
              <v-col cols="9">
                <v-autocomplete
                    v-model="form.customer_id"
                    label="Customer"
                    :items="customers"
                    item-text="name"
                    item-value="customer_id"
                    :disabled="disableCustomerField"
                >
                </v-autocomplete>
              </v-col>
              <v-col>
                <v-checkbox label="Edit Selected Customer" v-model="disableCustomerField"></v-checkbox>
              </v-col>
            </v-row>
            <v-autocomplete
                v-model="form.customer_name_id"
                label="Name associated with sample"
                :items="brands"
                item-text="name"
                item-value="id"
                clearable
            >
            </v-autocomplete>
            <v-text-field
                label="Manifest ID"
                v-model="form.manifest_id"
            >
            </v-text-field>
            <v-text-field v-model="form.name" label="Sample Name"></v-text-field>
            <v-autocomplete
                label="Sample Product Type"
                v-model="form.sample_cert_type_uuid"
                :items="sampleTypes"
                item-text="name"
                item-value="uuid"
                filled
            >
              <template v-slot:prepend>
                <v-chip :color="$store.$db().model('sampleCertTypes').find(form.sample_cert_type_uuid).color" small></v-chip>
              </template>
            </v-autocomplete>
            <v-text-field
                label="Qa"
                v-model="form.qa"
            >
            </v-text-field>
            <v-text-field
                label="Lot"
                v-model="form.lot"
            >
            </v-text-field>
            <v-radio-group v-model="form.is_rnd" row>
              <v-radio
                  label="QA"
                  :value="false"
              >
              </v-radio>
              <v-radio
                  label="RND"
                  :value="true"
              >
              </v-radio>
            </v-radio-group>
            <v-row justify="center">
              <v-btn-toggle v-model="selectedTestTypes" multiple>
                <v-btn
                    :active-class="disabledTestUpdate(type.uuid) ? 'yellow darken-1' : 'error white--text'"
                    :class="{'disable-events': disabledTestUpdate(type.uuid)}"
                    v-for="type in sampleTestTypes"
                    :key="type.uuid"
                    :value="type.uuid"
                >
                  {{type.name}}
                </v-btn>
              </v-btn-toggle>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="close" text>close</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="save" color="success">submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
name: "SampleEditForm",
  components:{

  },
  props:{
    sample: {
      required: true,
    }
  },
  data: () => ({
      show: false,
      loading: false,
      disableCustomerField: true,
      form: null,
      removeTests: [],
  }),
  computed: {
    sampleTypes(){
      return this.$store.$db().model('sampleCertTypes').all();
    },
    sampleTestTypes(){
      let types = this.$store.$db().model('sampleTestTypes').all();
      let filtered = this.$store.state.filtered_test_types || [];
      if (filtered.length === 0) return types;
      return types.filter(type => {
        if (!filtered.includes(type.uuid)) return true;
        let hasInForm = this.form && this.form.sample_tests && this.form.sample_tests.some(test => (test.sample_test_type_uuid === type.uuid || (test.test_type && test.test_type.uuid === type.uuid)) && test.active !== false);
        let hasInSample = this.sample && this.sample.sample_tests && this.sample.sample_tests.some(test => (test.sample_test_type_uuid === type.uuid || (test.test_type && test.test_type.uuid === type.uuid)) && test.active !== false);
        return hasInForm || hasInSample;
      });
    },
    unit(){
      return this.$store.$db().model('units').query().where('name', 'g').first();
    },
    selectedTestTypes:{
      get(){
        if(!this.form) return [];
        return this.form.sample_tests.filter(test => test.active).map( test => {
          return test.test_type.uuid
        })
      },
      set(v){
        if(this.selectedTestTypes.length > v.length){
          let findTestType = this.selectedTestTypes.find(type => !v.some(test => test === type))
          if(findTestType){
            for(let i in this.form.sample_tests){
              let test = this.form.sample_tests[i];
              if(test.sample_test_type_uuid === findTestType){
                if(test.mass.value_1 > 0 || test.sample_test_analyte_count >0 ){
                  this.$store.dispatch('showError', "This test has a weight or analyte already applied and cannot be removed. Test must be deactivated inside ConAn 3.")
                }else{
                  if(test.uuid){
                    this.removeTests.push(test);
                  }
                  this.form.sample_tests.splice(i, 1);
                }
              }
            }
          }
          console.log('remove');
        }else if(this.selectedTestTypes.length < v.length){
          let findTestType = v.find(type => !this.selectedTestTypes.some(test => test === type))
          if(findTestType){
            let findRemoved = this.removeTests.find(test => test.sample_test_type_uuid === findTestType);
            if(findRemoved){
              let index = this.removeTests.findIndex(test => test.sample_test_type_uuid === findTestType)
              this.form.sample_tests.push(findRemoved);
              this.removeTests.splice(index, 1);
            }else{
              let testTypeObject = this.$store.$db().model('sampleTestTypes').find(findTestType)
              this.form.sample_tests.push({
                uuid: null,
                sample_uuid: this.form.uuid,
                sample_test_type_uuid: findTestType,
                test_type: testTypeObject,
                display_index: 0,
                mass: 0,
                unit_uuid: this.unit.uuid,
                retest: false,
                passed: false,
                complete: false,
                active: true,
                created_by: this.$store.getters.id,
                updated_by: this.$store.getters.id,
              })
            }
          }
        }else{
          console.log('even')
        }
      }
    },
    customers(){
      return this.$store.$db().model('names').query().where('name_type_id', 1).get();
    },
    brands(){
      if(!this.form) return [];
      return this.$store.$db().model('names').query().where('customer_id', this.form.customer_id).get();
    }
  },
  mounted(){
    this.setSample()
  },
  watch:{
    show(v){
      this.setSample()
    }
  },
  methods:{
    setSample(){
      this.form = null;
      this.removeTests = [];
      this.form = {...this.sample, sample_tests: [...this.sample.sample_tests]};
    },
    disabledTestUpdate(type){
      return this.sample.sample_tests.some(test => test.sample_test_type_uuid === type && (test.mass.value_1 > 0 || test.sample_test_analyte_count > 0))
    },
    close(){
      this.setSample();
      this.show = false;
    },
    async save(){
      this.loading =true;
      await this.$store.$db().model('samples').api().save({
        ...this.form,
        sample_test: null,
      })
      await this.$store.$db().model('sampleTests').api().save({
        collection: this.form.sample_tests
      })
      if(this.removeTests.length > 0){
        for(let i in this.removeTests){
          await this.$store.$db().model('sampleTests').api().destroy(this.removeTests[i].uuid, 'Deleted required test: '+this.removeTests[i].test_type.name);
        }
      }
      this.setSample();
      this.loading = false
    }
  }
}
</script>

<style scoped>
.disable-events {
  pointer-events: none;
}
</style>
